import { useTranslation } from 'react-i18next'

import GlobeIcon from '@wwt/shared/assets/icons/outline/globe.svg'

import { NestedMenuItem } from '@/shared/ui/NestedMenu'
import { UnderDevelopment } from '@/shared/ui/UnderDevelopment'

export const TranslationsMenu = () => {
	const { t } = useTranslation('header')

	return (
		<UnderDevelopment asChild>
			<NestedMenuItem
				to="translations"
				data-wwt-id="header__burger-language--button"
				disabled
			>
				<GlobeIcon />
				{t('translation.title')}
			</NestedMenuItem>
		</UnderDevelopment>
	)
}
